// useSortable's comparator as a pure function (47160: the paginated Payment History parity script runs it against the API's port, lib/payHistory.js).
// nulls last in both directions; two numbers compare numerically; anything else localeCompare (numeric, base sensitivity). Array sort is stable.
export function sortRows(data, key, dir, sortKeyMap = {}) {
  return [...(data || [])].sort((a, b) => {
    if (!key) return 0;
    const sk = sortKeyMap[key] || key;
    const av = a[sk], bv = b[sk];
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;
    const cmp =
      typeof av === 'number' && typeof bv === 'number'
        ? av - bv
        : String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });
    return dir === 'asc' ? cmp : -cmp;
  });
}
